export default "__VITE_ASSET__vho$Ai$5__"